import { Select } from 'antd'
import { Component } from 'react'
import { PmsAPI } from '../../controller/PmsAPI'

export class PmsRoomSelect extends Component {
    state = {
        roomCodes: [],
        loading: false,
    }
    
    componentDidMount() {
        this.fetchRoomCodes();
    }
    
    fetchRoomCodes = async () => {
        this.setState({ loading: true });
        try {
            // 不帶條件獲取所有房型代碼列表
            const response = await PmsAPI.room.getAllRoomCodes();
            const result = response.data;
            
            // 從 items 中提取唯一的房型代碼
            const uniqueRoomCodes = [...new Set(result.items.map(item => item.room_cod))]
                .filter(Boolean)
                .map(roomCod => ({
                    value: roomCod,
                    label: roomCod
                }))
                .sort((a, b) => a.value.localeCompare(b.value));
                
            this.setState({ roomCodes: uniqueRoomCodes });
        } catch (error) {
            console.error('Failed to fetch room codes:', error);
        } finally {
            this.setState({ loading: false });
        }
    }
    
    render() {
        return (
            <Select 
                loading={this.state.loading} 
                style={{ minWidth: 120 }} 
                allowClear={true}
                placeholder="選擇房型"
                {...this.props}
            >
                {this.state.roomCodes.map((roomCode) => 
                    <Select.Option key={roomCode.value} value={roomCode.value}>
                        {roomCode.label}
                    </Select.Option>
                )}
            </Select>
        )
    }
}

export default PmsRoomSelect